import React, { FC } from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const StepSummaryChip: FC<{ success: boolean | null }> = ({ success }) => {
  if (success === true) return <Chip label="All Steps Passed" color="success" size="small" icon={<CheckCircleIcon />} />;
  if (success === false) return <Chip label="Some Steps Failed" color="error" size="small" icon={<ErrorIcon />} />;
  return <Chip label="In Progress" color="warning" size="small" icon={<HourglassEmptyIcon />} />;
};

export default StepSummaryChip;
